// extracted by mini-css-extract-plugin
module.exports = {"quickAlertCardImg":"EmptyAlertListMessage_quickAlertCardImg__gXwDu"};